import {
    VIRTUAL_KEY_PRESSED,
    ON_PASSWORD_CHANGED,
    PHYSICAL_KEY_PRESSED,
    SUBMIT_VIRTUAL_PASSWORD, VALIDATE_PIN
} from './actionTypes';

/**
 * Event for key pressed.
 *
 * @param {Object} props - The props needed to handling key pressed on virtual keyboard.
 * @returns {{
 *     type: VIRTUAL_KEY_PRESSED,
 *     keyValue: string
 * }}
 */
export function virtualKeyPressed(keyValue) {
    return {
        type: VIRTUAL_KEY_PRESSED,
        keyValue
    };
}

/**
 * Event for key pressed.
 *
 * @param {Object} props - The props needed to handling key pressed on physical keyboard.
 * @returns {{
 *     type: PHYSICAL_KEY_PRESSED,
 *     keyboardEvent: Object
 * }}
 */
export function physicalKeyPressed(keyboardEvent) {
    return {
        type: PHYSICAL_KEY_PRESSED,
        keyboardEvent
    };
}

/**
 * Event from Dialog password.
 *
 * @param {Object} props - The props needed to signals that a password in dialog was entered.
 * @returns {{
 *     type: ON_PASSWORD_CHANGED,
 *     password: String
 * }}
 */
export function onPasswordChanged(password) {
    return {
        type: ON_PASSWORD_CHANGED,
        password
    };
}

/**
 * Event from virtual keyboard.
 *
 * @param {Object} props - The props needed to signals that a virtual enter was pressed
 * and send password.
 * @returns {{
 *     type: SUBMIT_VIRTUAL_PASSWORD,
 *     enabled: Boolean
 * }}
 */
export function submitVirtualPassword(enabled) {
    return {
        type: SUBMIT_VIRTUAL_PASSWORD,
        payload: enabled
    };
}


/**
 * Event from virtual keyboard.
 *
 * @param {Object} props - The props needed to signals that a pin correct
 * and send password.
 * @returns {{
 *     type: VALIDATE_PIN,
 *     pinData: String
 * }}
 */
export function wizyValidatePin(value) {
    return {
        type: VALIDATE_PIN,
        pinData: value
    };
}
